'use strict';

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _currentOpenings = require('./current-openings');

var _currentOpenings2 = _interopRequireDefault(_currentOpenings);

var _slideshow = require('./slideshow');

var _slideshow2 = _interopRequireDefault(_slideshow);

var _lifeAtHellosign = require('./life-at-hellosign');

var _lifeAtHellosign2 = _interopRequireDefault(_lifeAtHellosign);

var _testimonials = require('./testimonials');

var _testimonials2 = _interopRequireDefault(_testimonials);

var _weveGotYouCovered = require('./weve-got-you-covered');

var _weveGotYouCovered2 = _interopRequireDefault(_weveGotYouCovered);

var _our_values_ = require('./assets/our_values_01.svg');

var _our_values_2 = _interopRequireDefault(_our_values_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var JOBS_URL = 'https://jobs.lever.co/hellosign';

function CareersPage(props) {
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page' },
        _react2['default'].createElement(Header, null),
        _react2['default'].createElement(_currentOpenings2['default'], { departments: props.departments, jobsUrl: JOBS_URL }),
        _react2['default'].createElement(_slideshow2['default'], null),
        _react2['default'].createElement(WhatWeValue, null),
        _react2['default'].createElement(_lifeAtHellosign2['default'], null),
        _react2['default'].createElement(_testimonials2['default'], null),
        _react2['default'].createElement(_weveGotYouCovered2['default'], null),
        _react2['default'].createElement(JoinUs, { jobsUrl: JOBS_URL })
    );
}

function Header() {
    return _react2['default'].createElement(
        'header',
        null,
        _react2['default'].createElement(
            'h1',
            null,
            'Our mission is to build something that makes the lives of millions of people easier. Join us!'
        )
    );
}

function WhatWeValue() {
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--what-we-value row' },
        _react2['default'].createElement(
            'div',
            { className: 'columns small-12 medium-6 large-4' },
            _react2['default'].createElement(
                'h2',
                null,
                'What we value'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'We\'re a fun and driven group, dedicated to meaningful work. HelloSign\'s core values are our not-so-secret weapons.  They\'re posted in every conference room, right next to our whiteboards, so we can use them in real time.  They surfaced directly from our team! Our values guide our decision-making and how we work together everyday, so we all collectively own building a culture that we thrive in.'
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'm-careers-page--our-values columns small-12 medium-6 large-6 large-offset-2' },
            _react2['default'].createElement(
                'h3',
                null,
                'OUR VALUES'
            ),
            _react2['default'].createElement('img', { src: _our_values_2['default'] })
        )
    );
}

function JoinUs(props) {
    var jobsUrl = props.jobsUrl;
    var buttonClassName = 'm-button m-careers-page--join-us--button bg-cerulean hbg-castle-rock c-white hc-white';
    return _react2['default'].createElement(
        'div',
        { className: 'm-careers-page--join-us' },
        _react2['default'].createElement(
            'h2',
            null,
            'Join us.'
        ),
        _react2['default'].createElement(
            'a',
            { href: jobsUrl, className: buttonClassName, target: '_blank', rel: 'noopener noreferrer' },
            'VIEW JOB OPENINGS'
        )
    );
}

module.exports = CareersPage;


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/careers-page/index.jsx
 ** module id = 1553
 ** module chunks = 0
 **/